/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보관 통계 호출 함수
 * 버전 : 1.0
 * 파일명 : useLoadPromoterAnalysis.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2026-01-30, 강동형 : name값 추가
 * ================================================================*/

import { getPromoterAnalysis } from "src/api/Admin";

export interface PromoterAnalysiseData{
    user_id: string,
    user_name: string,
    participation_count: number,
    sum_total_cnt: number,
    sum_interested_cnt: number,
    sum_apply_cnt: number,
    commissioned_count: number,
    not_interested_count: number 
}

export const LoadPromoterAnalysis = async (target_name:string, start_date: string|null, end_date: string|null)=>{
    const response = await getPromoterAnalysis(target_name, start_date, end_date)
    return response.data as PromoterAnalysiseData[]
}